module.exports = __webpack_public_path__ + "static/media/Retrigger.5b5ae05a.svg";